import React from "react";

export default function PageHero({ eyebrow, title, sub, image }) {
    return (
        <section data-testid="page-hero" className="relative pt-28 pb-20 sm:pt-36 sm:pb-28 overflow-hidden">
            {image && (
                <>
                    <div
                        className="absolute inset-0 bg-cover bg-center opacity-25"
                        style={{ backgroundImage: `url(${image})` }}
                    />
                    <div className="absolute inset-0 bg-gradient-to-b from-brand-bg via-brand-bg/80 to-brand-bg" />
                </>
            )}
            <div className="relative max-w-7xl mx-auto px-4 sm:px-8">
                {eyebrow && (
                    <p className="text-xs uppercase tracking-[0.3em] text-brand-secondary font-bold mb-5">{eyebrow}</p>
                )}
                <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl text-brand-primary leading-[1.02] font-semibold tracking-tight max-w-4xl">
                    {title}
                </h1>
                {sub && (
                    <p className="mt-6 text-base sm:text-lg text-brand-textMuted leading-relaxed max-w-2xl">
                        {sub}
                    </p>
                )}
            </div>
        </section>
    );
}
